var waitFor = require("../utils/waitFor");

waitFor(
  "body.page-template-channel-partners, body.page-template-channel-partners-new",
  function () {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoic2VsZmludGVyYWN0aXZlIiwiYSI6ImNqdm16a21iYjFodjY0OHJ1d3l6MTF0aXIifQ.Q2DxdyOJW_fxigsHp6Kysg";
    var mymap = new mapboxgl.Map({
      container: "sales-agents-map",
      center: [0, 0],
      style: "mapbox://styles/mapbox/streets-v11", // style URL
      zoom: $(window).width() > 700 ? 1 : 1,
      scrollWheelZoom: false,
    });

    for (var country in posi_country_pins) {
      var latlong = posi_country_pins[country];
      (function (country, latlong) {
        var marker = new mapboxgl.Marker()
          .setLngLat([latlong[1], latlong[0]])
          .addTo(mymap);

        $(marker.getElement()).on("click", function (e) {
          $("html, body").animate(
            {
              scrollTop: $("#country-" + country).offset().top - 20,
            },
            1000
          );
        });
      })(country, latlong);
    }

    window.findDistributorCountryChange = function () {
      var country = $("#distributors-country-dropdown").val();

      $("html, body").animate(
        {
          scrollTop: $("#country-" + country).offset().top - 20,
        },
        1000
      );
    };
  }
);
